import React, { useState } from 'react';
import { Search } from 'lucide-react';

const SearchComponent = ({ 
  placeholder = "Search", 
  onSearch, 
  className = "",
  showIcon = true,
  value,
  onChange
}) => {
  const [searchValue, setSearchValue] = useState(value || '');

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    
    // If onChange prop is provided, use it
    if (onChange) {
      onChange(newValue);
    }
    
    // If onSearch prop is provided, call it with the new value
    if (onSearch) {
      onSearch(newValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchValue);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`w-full mt-3 ${className}`}>
      <div className="w-[95%] mx-auto relative">
        {showIcon && (
          <Search 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#697077]" 
          />
        )}
        <input
          type="text"
          placeholder={placeholder}
          value={searchValue}
          onChange={handleInputChange}
          className={`
            w-full 
            ${showIcon ? 'pl-12' : 'pl-4'} 
            pr-4 
            py-3 
            border-[1px] 
            border-[#D9D9D9]
            dark:border-[#32353c]
            bg-white 
            dark:bg-[#1d2026]
            text-gray-900 
            dark:text-white
            placeholder-[#697077] 
            dark:placeholder-gray-500
            focus:outline-none 
            focus:ring-1 
            focus:ring-blue-500 
            focus:border-blue-500 
            transition-colors 
            duration-200
          `}
        />
      </div>
    </form>
  );
};

export default SearchComponent;